var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_approvalProcess_form_leaveTitle"),
      backgroundClass: "transparent",
      widthClass: "max-1000",
      pad: "0",
    },
    scopedSlots: _vm._u(
      [
        {
          key: "nav-actions",
          fn: function () {
            return [
              _vm.can_be_cancel
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      staticClass: "primary mr-4",
                                      attrs: {
                                        icon: "",
                                        color: "white",
                                        width: "40",
                                        height: "40",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          _vm
                                            .$confirmWarn(
                                              _vm.$t(
                                                "message_essweb_LeaveApplication_form_dialog_cancelApplicationTitle"
                                              ),
                                              _vm.$t(
                                                "message_essweb_LeaveApplication_form_dialog_cancelApplicationLabel"
                                              )
                                            )
                                            .then(function (res) {
                                              if (res) {
                                                _vm.toDelete(null)
                                              }
                                            })
                                        },
                                      },
                                    },
                                    on
                                  ),
                                  [
                                    _c("svg-icon", {
                                      attrs: {
                                        size: "24",
                                        fill: "white",
                                        iconClass: "application-cancel",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        689409078
                      ),
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("label_essweb_form_tools_cancelBtnLabel")
                          )
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.Data && _vm.Data["flow_status"] == 1
                ? _c("approvalTools", {
                    attrs: {
                      curUuid: _vm.Data["uuid"],
                      staff_uuid: _vm.curStaff,
                      flag: _vm.Data["cancel_flag"],
                      data_type: _vm.Data["data_type"],
                      final_node: Number(_vm.Data["is_final_task_node"]),
                      matched: Number(_vm.Data["is_match"]) ? true : false,
                      canRevoke: Number(_vm.Data["is_allow_revoke"]),
                      canRollback: Number(_vm.Data["is_allow_rollback"]),
                      canForward: Number(_vm.Data["is_allow_forward"]),
                    },
                    on: {
                      back: _vm.onBack,
                      forward: _vm.onForward,
                      approval: _vm.onApproval,
                      reject: _vm.onReject,
                    },
                  })
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        _vm.Data
          ? {
              key: "page-main",
              fn: function () {
                return [
                  _vm.Data
                    ? _c("ApprovalTriger", {
                        attrs: {
                          "bg-color": _vm.Data.approval_bg_color,
                          "slide-color": _vm.Data.approval_tint_color,
                        },
                        on: {
                          triger: function ($event) {
                            return _vm.$toPage(
                              "/admin/approval-process/leave-detail/" +
                                _vm.$route.params.params +
                                "/approval-detail/" +
                                _vm.$route.params.params
                            )
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "time",
                              fn: function () {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getDateTime(
                                          _vm.Data.operate_utc_datetime,
                                          "YYYY/MM/DD HH:mm"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "status",
                              fn: function () {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          _vm.Data.status_detail
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2072884572
                        ),
                      })
                    : _vm._e(),
                  _c(
                    "Section",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "6",
                                md: "6",
                                lg: "6",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text--secondary" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_leaveApplication_form_swiftNumberLabel"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  readonly: "",
                                  label: _vm.$t(
                                    "label_essweb_leaveApplication_form_swiftNumberLabel"
                                  ),
                                  "single-line": "",
                                  dense: "",
                                },
                                model: {
                                  value: _vm.Data.swift_number,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.Data, "swift_number", $$v)
                                  },
                                  expression: "Data.swift_number",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "6",
                                md: "6",
                                lg: "6",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text--secondary" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_leaveApplication_form_submitDateLabel"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  readonly: "",
                                  value: _vm.$getDateTime(
                                    _vm.Data.submission_utc_datetime,
                                    "YYYY/MM/DD HH:mm"
                                  ),
                                  label: _vm.$t(
                                    "label_essweb_leaveApplication_form_submitDateLabel"
                                  ),
                                  "single-line": "",
                                  dense: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "12",
                                md: "12",
                                lg: "12",
                                cols: "12",
                              },
                            },
                            [
                              _c("AutoComplete", {
                                attrs: {
                                  label:
                                    "label_essweb_leaveApplication_form_applicantLabel",
                                  readonly: "",
                                  chips: "",
                                  avatar: "",
                                  "two-line": "",
                                  "small-chips": "",
                                  items: _vm.users,
                                  "item-value": "uuid",
                                  "item-text": "preferred_name",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection.avatar",
                                      fn: function (ref) {
                                        var data = ref.data
                                        return [
                                          _c("StaffAvatar", {
                                            attrs: {
                                              src: data.item.staff_avatar,
                                              left: "",
                                              small: "",
                                              isTemp: data.item.is_temp,
                                              staff_name:
                                                data.item.preferred_name,
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                    {
                                      key: "selection",
                                      fn: function (ref) {
                                        var data = ref.data
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  data.item.preferred_name
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3219670475
                                ),
                                model: {
                                  value: _vm.user,
                                  callback: function ($$v) {
                                    _vm.user = $$v
                                  },
                                  expression: "user",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Section",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "6",
                                md: "6",
                                lg: "6",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text--secondary" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_leaveApplication_form_leaveTypeLabel"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  readonly: "",
                                  value:
                                    _vm.$getCommonLangValue(
                                      _vm.Data.leave_type_name
                                    ) +
                                    (Number(_vm.Data.cancel_flag) == 1
                                      ? "(" +
                                        _vm.$t(
                                          "label_essweb_LeaveApplication_list_tag_cancelLabel"
                                        ) +
                                        ")"
                                      : ""),
                                  label: _vm.$t(
                                    "label_essweb_leaveApplication_form_leaveTypeLabel"
                                  ),
                                  "single-line": "",
                                  dense: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "6",
                                md: "6",
                                lg: "6",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text--secondary" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_leaveApplication_form_leaveTransactionTypeLabel"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  readonly: "",
                                  value: _vm.$getCommonLangValue(
                                    _vm.Data.leave_transaction_type_name
                                  ),
                                  label: _vm.$t(
                                    "label_essweb_leaveApplication_form_leaveTransactionTypeLabel"
                                  ),
                                  "single-line": "",
                                  dense: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "6",
                                md: "6",
                                lg: "6",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text--secondary" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_leaveApplication_form_startDateLabel"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  readonly: "",
                                  value: _vm.$getDateTime(
                                    _vm.Data.start_utc_datetime,
                                    "YYYY/MM/DD"
                                  ),
                                  label: _vm.$t(
                                    "label_essweb_leaveApplication_form_startDateLabel"
                                  ),
                                  "single-line": "",
                                  dense: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "6",
                                md: "6",
                                lg: "6",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text--secondary" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_leaveApplication_form_endDateLabel"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  readonly: "",
                                  value: _vm.$getDateTime(
                                    _vm.Data.end_utc_datetime,
                                    "YYYY-MM-DD"
                                  ),
                                  label: _vm.$t(
                                    "label_essweb_leaveApplication_form_endDateLabel"
                                  ),
                                  "single-line": "",
                                  dense: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "12",
                                md: "12",
                                lg: "12",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text--secondary" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_leaveApplication_form_durationLabel"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  readonly: "",
                                  value:
                                    parseFloat(
                                      Number(_vm.Data.total_time || 0)
                                    ) +
                                    (_vm.Data.unit === "D"
                                      ? _vm.$t("label_essweb_system_dayLabel")
                                      : _vm.Data.unit === "H"
                                      ? _vm.$t("label_essweb_system_hourLabel")
                                      : ""),
                                  label: _vm.$t(
                                    "label_essweb_leaveApplication_form_durationLabel"
                                  ),
                                  "single-line": "",
                                  dense: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "12",
                                md: "12",
                                lg: "12",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text--secondary" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_leaveApplication_form_leaveReasonLabel"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  readonly: "",
                                  value: _vm.$getCommonLangValue(
                                    _vm.Data.leave_reason_name
                                  ),
                                  label: _vm.$t(
                                    "label_essweb_leaveApplication_form_leaveReasonLabel"
                                  ),
                                  "single-line": "",
                                  dense: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.Data.attachments.length != 0
                            ? _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_leaveApplication_form_attachmentLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("ImgDragUpdate", {
                                    attrs: {
                                      defaultImageList: _vm.Data.attachments,
                                      disabled: "",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xs: "12",
                                sm: "12",
                                md: "12",
                                lg: "12",
                                cols: "12",
                              },
                            },
                            [
                              _c(
                                "v-sheet",
                                { staticClass: "text--secondary" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_leaveApplication_form_messageLabel"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  readonly: "",
                                  label: _vm.$t(
                                    "label_essweb_leaveApplication_form_messageLabel"
                                  ),
                                  "single-line": "",
                                  dense: "",
                                },
                                model: {
                                  value: _vm.Data.remarks,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.Data, "remarks", $$v)
                                  },
                                  expression: "Data.remarks",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            }
          : null,
        {
          key: "tools-main",
          fn: function () {
            return undefined
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }